var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOrbitalMechanicsEnabled)?_c('span',{staticClass:"text-warning",attrs:{"title":"Orbital Mechanics may affect waypoint ETAs"}},[_vm._v("*")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }